import { Button, Form, Input, Space } from 'antd';
import { FC } from 'react';

import { ButtonSuccess } from '@/common/components';
import { AppFormProps } from '@/common/interfaces';
import { defineInputStatus } from '@/common/utils';

import { SearchConsoleAccountsFormFirstStepFields, SearchConsoleAccountsFormFirstStepInputs } from '@/modules/DomainsApi';

interface Props extends AppFormProps<typeof SearchConsoleAccountsFormFirstStepInputs, SearchConsoleAccountsFormFirstStepFields> {}

export const FirstStepView: FC<Props> = ({
  formName,
  formType,
  form,
  initialValues,
  formErrors,
  isFormLoading,
  validationSchema,
  handleBack,
  handleFinish,
  handleFinishFailed
}) => {
  return (
    <Form
      form={ form }
      name={ formName }
      layout="vertical"
      initialValues={ initialValues }
      disabled={ isFormLoading }
      autoComplete="off"
      onFinish={ handleFinish }
      onFinishFailed={ handleFinishFailed }
    >
      <Form.Item name={ SearchConsoleAccountsFormFirstStepInputs.Provider } hidden/>

      <Form.Item
        label="E-mail"
        name={ SearchConsoleAccountsFormFirstStepInputs.Email }
        hasFeedback
        help={ formErrors?.email }
        validateStatus={ defineInputStatus(isFormLoading, formErrors?.email) }
        rules={ validationSchema.email }
      >
        <Input allowClear disabled={ formType === 'edit' || isFormLoading }/>
      </Form.Item>

      <Form.Item
        label="Пароль"
        name={ SearchConsoleAccountsFormFirstStepInputs.Password }
        hasFeedback
        help={ formErrors?.password }
        validateStatus={ defineInputStatus(isFormLoading, formErrors?.password) }
        rules={ validationSchema.password }
      >
        <Input.Password allowClear/>
      </Form.Item>

      <Form.Item
        label="Додаткова адреса електронної пошти"
        name={ SearchConsoleAccountsFormFirstStepInputs.BackupEmailAddress }
        hasFeedback
        help={ formErrors?.backupEmailAddress }
        validateStatus={ defineInputStatus(isFormLoading, formErrors?.backupEmailAddress) }
        rules={ validationSchema.backupEmailAddress }
      >
        <Input allowClear/>
      </Form.Item>

      <Form.Item wrapperCol={{ span: 24 }}>
        <Space align="center" style={{ width: '100%', justifyContent: 'flex-end' }}>
          <Button type="default" onClick={ handleBack }>
            Скасувати
          </Button>
          <ButtonSuccess loading={ isFormLoading } type="primary" htmlType="submit">
            { formType === 'edit' ? 'Зберегти та вийти' : 'Створити' }
          </ButtonSuccess>
        </Space>
      </Form.Item>
    </Form>
  );
};
